import React from 'react';
import { FacilityCheckin } from '@pass-frontend/features/facility-checkin/ui';

export function Index() {
  return <FacilityCheckin />;
}

export default Index;
